// ========================================
// Constants
// ========================================

export const PREFIX_OPTIONS = [
  { value: "นาย", label: "นาย" },
  { value: "นาง", label: "นาง" },
  { value: "นางสาว", label: "นางสาว" },
  { value: "บริษัท", label: "บริษัท" },
  { value: "ห้างหุ้นส่วน", label: "ห้างหุ้นส่วน" },
];

export const RELATION_OPTIONS = [
  { value: "สามี", label: "สามี" },
  { value: "ภรรยา", label: "ภรรยา" },
  { value: "บุตร", label: "บุตร" },
  { value: "บิดา", label: "บิดา" },
  { value: "มารดา", label: "มารดา" },
  { value: "ญาติ", label: "ญาติ" },
  { value: "เพื่อน", label: "เพื่อน" },
  { value: "กรรมการผู้มีอำนาจลงนาม", label: "กรรมการผู้มีอำนาจลงนาม" },
  { value: "ผู้ชำระบัญชี", label: "ผู้ชำระบัญชี" },
  { value: "หุ้นส่วนผู้จัดการ", label: "หุ้นส่วนผู้จัดการ" },
  { value: "ตัวแทนโดยชอบธรรม", label: "ตัวแทนโดยชอบธรรม" },
  { value: "ผู้รับมอบอำนาจ", label: "ผู้รับมอบอำนาจ" },
];

export const NATION_OPTIONS = [
  { value: "ไทย", label: "ไทย" },
  { value: "ลาว", label: "ลาว" },
  { value: "พม่า", label: "พม่า" },
  { value: "กัมพูชา", label: "กัมพูชา" },
  { value: "เวียดนาม", label: "เวียดนาม" },
  { value: "อื่นๆ", label: "อื่นๆ" },
];

export const FORM_LAYOUT = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

export const UPLOAD_MAX_SIZE_MB = 5.1;
